import { useRevenueFee } from '~/@pages_investing/_utils/revenue-fee/useRevenueFee'
import { useUser } from '~/@biz_account/useUser/useUser'
import { useApiClientDocument } from '~/@api/client/useApiClientDocument'
import { downloadPDF } from '~/@lib/utils/files.utils'

export const useFeeNotification = () => {
  const client = useApiClientDocument()
  const { user } = useUser()
  const { revenueFeeSetting, isReady } = useRevenueFee()

  // Nest `GET /document/fee-notice` (`/document` doc, apiClientDocument) — presunuté z Meteor
  // `user/account/portfolio/documents/fee-notice-document`, PDF v base64 v `data`.
  async function downloadFeeNoticeDocument() {
    return client.document
      .pdfGeneratorsControllerGetFeeNotice({
        secure: true,
      })
      .then(({ data }) => {
        downloadPDF(data.data, 'oznamenie-o-zmene-ramcovej-zmluvy.pdf')
      })
  }

  const feeStartDateNice = new Date(
    revenueFeeSetting?.validFrom ?? '2025-09-01'
  ).toLocaleDateString('sk-SK', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  })

  const initialText = `S účinnosťou od ${feeStartDateNice} dochádza k jednostrannej zmene Rámcovej zmluvy, ktorá sa týka zavedenia poplatku za správu nových investícií.`

  return {
    isNotificationReady: user != null && isReady,
    notificationText: user?.hasRevenueFeeImmunity
      ? `${initialText} Vy však máte poplatkovú imunitu až do konca 2026, preto ich neplatíte. Viac v`
      : `${initialText} Podrobnosti k zmene nájdete v tomto`,
    downloadFeeNoticeDocument,
  }
}
